import { Announcement } from '@/modules/announcement/models/Announcement';
import { unseenAnnouncements } from '@/modules/announcement/store/announcement.state';

export function setUnseenAnnouncements(announcements: Announcement[]): void {
  unseenAnnouncements.value = announcements;
}

export function filterUnseenAnnouncements(filterFn: (announcement: Announcement) => boolean): void {
  if (!unseenAnnouncements.value) {
    return;
  }
  unseenAnnouncements.value = unseenAnnouncements.value.filter(filterFn);
}
